<template>
  <work-editor-main mode="create" />
</template>

<script>
import WorkEditorMain from './WorkEditorMain.vue'

export default {
  name: 'CreateWork2',
  components: {
    WorkEditorMain
  }
}
</script>
